import 'react-day-picker/style.css';
import '~/themes/calendar.scss';

import { addDays } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import { Box, Text } from '~/commonComponents';
import { HeadRow } from '~/components/Request/multiday/components/Rows/DateRow/HeadRow';
import { SectionCard } from '~/components/ShiftRequestRedesign/common';
import { MonthNavigation } from './MonthNavigation';
import { TipBanner } from './TipBanner';
import { SelectedDatesList } from './SelectedDatesList';

interface IDatesCardProps {
  selectedDates: Date[];
  tipVisible: boolean;
  onCalendarSelect: (dates: Date[] | undefined) => void;
  onRemoveDate: (date: Date) => void;
}

export const DatesCard = ({
  selectedDates,
  tipVisible,
  onCalendarSelect,
  onRemoveDate,
}: IDatesCardProps) => {
  const today = new Date();

  return (
    <SectionCard title="Dates" testId="dates-card">
      <Text fontSize={16} fontWeight={400} color="neutral_500">
        Shifts can be posted up to 99 days in advance. Use the calendars to select your dates.
      </Text>

      <Box marginTop={14}>
        <TipBanner visible={tipVisible} />
      </Box>

      <Box alignItems="center">
        <DayPicker
          data-testid="dates-calendar"
          data-cy="dates-calendar"
          mode="multiple"
          numberOfMonths={2}
          selected={selectedDates}
          onSelect={onCalendarSelect}
          startMonth={today}
          components={{
            MonthCaption: MonthNavigation,
            Weekdays: HeadRow,
          }}
          disabled={[
            {
              before: today,
              after: addDays(today, 99),
            },
          ]}
        />
      </Box>

      <Box marginTop={20}>
        <SelectedDatesList dates={selectedDates} onRemoveDate={onRemoveDate} />
      </Box>
    </SectionCard>
  );
};
